module.exports = __webpack_public_path__ + "img/balcony_1_tn.a45be0b9.jpg";